import { useQuery } from '@apollo/client';
import { GetFinishedSessionsDocument, GetFinishedSessionsQuery, GetFinishedSessionsQueryVariables } from '../../../graphql/graphql-operations';
import { styled } from '@mui/material';
import { Box } from '@mui/system';
import counterBackground from '../../../assets/qr/gr-launch-background.png';
import { Flex } from '../../components/Flex';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ResqueLogo } from '../../../assets/svg/vr-resque-logo.svg';

const BackgroundWrapper = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  min-height: 100dvh;
  background-image: url(${counterBackground});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;

const ContentWrapper = styled(Flex)`
  padding: 2rem;
  min-height: 100dvh;
`;

const Counter = styled('h1')(({ theme }) => ({
    color: '#f66',
    fontWeight: 'bold',
    marginLeft: '3rem',
    marginRight: '3rem',
    lineHeight: 1.2,
    maxWidth: '80%',
}));

const Hash = styled('span')(({ theme }) => ({
    color: theme.palette.common.black,
    fontSize: '3.75rem',
    marginTop: '2rem',
    fontWeight: 700
}));

const CounterText = styled(Counter)`
    font-size: 8rem;
    margin: 0 1rem;
    color: #f66;
`;

const CounterLabel = styled('span')(({ theme }) => ({
    color: theme.palette.common.black,
    fontSize: '3.75rem',
    fontWeight: 700,
}));



export const getSessionQueryParams = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const companyIds = params.get('companyIds')?.split(',') || [];
    const from = params.get('from') || null;

    return {
        companyIds,
        from
    };
};

const QRCounter = () => {
    const { t } = useTranslation();
    const { data } = useQuery<GetFinishedSessionsQuery, GetFinishedSessionsQueryVariables>(
        GetFinishedSessionsDocument,
        {
            variables: {
                input: getSessionQueryParams()
            },
            pollInterval: 15000,
        }
    );

    return (
        <BackgroundWrapper>
            <ContentWrapper flexDirection="column" alignItems="center" justifyContent="center">
                <ResqueLogo style={{ height: 300 }} />
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    mt={20}
                    mb={8}
                    gap={6}
                >
                    <CounterLabel>{t('qrCounter.trained', 'Proškoleno')}</CounterLabel>
                    <CounterText>{data?.finishedSessions != null
                        ? new Intl.NumberFormat('cs-CZ').format(data.finishedSessions)
                        : ''}</CounterText>
                    <CounterLabel>{t('qrCounter.users', 'účastníků')}</CounterLabel>
                </Flex>
                <Flex alignItems="center">
                    <Hash>{t('qrCounter.slogan.prefix', 'Každý má')}{' '}
                        <Hash sx={{ color: '#f66', marginTop: 0 }}>
                            {t('qrCounter.slogan.hashTag', '#mocPOmoc')}
                        </Hash>
                    </Hash>
                </Flex>
            </ContentWrapper>
        </BackgroundWrapper>
    );
};

export default QRCounter;
